import { createContext, ReactNode, useContext } from 'react';
import { useWebSocketConfiguration } from './useWebSocketConfiguration';
import { useAppDispatch } from '../../configuration/setup/hooks';
import { storeCharger } from '../../pages/infrastructure/infrastructureSlice';
import { UseWebSocket } from './websocket.types';
import { storeMission } from '../../pages/missions/missionsSlice';

const WebSocketContext = createContext<UseWebSocket | undefined>(undefined);

interface WebSocketProviderProps {
    children: ReactNode;
}

export const WebSocketProvider = ({ children }: WebSocketProviderProps) => {
    const dispatch = useAppDispatch();

    const ws = useWebSocketConfiguration({
        messageHandlers: {
            CHARGING_STATION: (payload) => dispatch(storeCharger(payload)),
            MISSION_LIST: (payload) => dispatch(storeMission(payload.data)),
        },
        onOpen: () => console.log('[WS] Connection opened'),
        onClose: () => console.log('[WS] Connection closed'),
        onError: (e) => console.error('[WS] Connection error', e),
    });

    return <WebSocketContext.Provider value={ws}>{children}</WebSocketContext.Provider>;
};

export const useWebSocket = () => {
    const context = useContext(WebSocketContext);
    if (!context) {
        throw new Error('useWebSocket must be used within a WebSocketProvider');
    }
    return context;
};
